import React from 'react';
import { MatrixDashboardKPIs } from './types';

interface Props {
  kpis: MatrixDashboardKPIs;
  onRefresh?: () => void;
  onCheckExpired?: () => void;
}

export const ComplianceMatrixMetricsCards: React.FC<Props> = ({ kpis, onRefresh: _onRefresh, onCheckExpired: _onCheckExpired }) => {
  return (
    <div className="stats-grid">
      <div className="stat-card">
        <span className="stat-label">Overall Compliance Rate</span>
        <span className="stat-value" style={{ color: '#2563eb' }}>%{kpis.overall_compliance_rate}</span>
        <span className="stat-sub">{kpis.compliant_entries}/{kpis.total_entries} Fully Compliant</span>
      </div>

      <div className="stat-card">
        <span className="stat-label">Bridge Mapping Coverage</span>
        <span className="stat-value" style={{ color: '#0d9488' }}>%{kpis.average_mapping_coverage}</span>
        <span className="stat-sub">Evidence Coverage: %{kpis.average_evidence_coverage}</span>
      </div>

      <div className="stat-card">
        <span className="stat-label">Action Triggers</span>
        <span className="stat-value" style={{ color: kpis.reassessment_required_count > 0 ? '#d97706' : '#64748b' }}>
          {kpis.reassessment_required_count}
        </span>
        <span className="stat-sub">{kpis.expired_evidence_count} Expired Evidence Records</span>
      </div>

      <div className="stat-card">
        <span className="stat-label">Status Distribution</span>
        <span className="stat-value" style={{ color: '#059669' }}>
          {kpis.compliant_entries} / {kpis.total_entries}
        </span>
        <span className="stat-sub">{kpis.non_compliant_entries} Non-Compliant • {kpis.partially_compliant_entries} Partial</span>
      </div>
    </div>
  );
};
